import { __exportAll } from "../_virtual/_rolldown/runtime.js";

//#region src/type/index.ts
var type_exports = /* @__PURE__ */ __exportAll({});

//#endregion
export { type_exports };
//# sourceMappingURL=index.js.map